import { render, staticRenderFns } from "./ZoneDetail.vue?vue&type=template&id=ee844a1e&scoped=true&"
import script from "./ZoneDetail.vue?vue&type=script&lang=js&"
export * from "./ZoneDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZoneDetail.vue?vue&type=style&index=0&id=ee844a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee844a1e",
  null
  
)

export default component.exports